import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Container = styled.div`
  position: fixed;
  display: flex;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  z-index: 9999;
  .alert {
    background-color: ${Variables.colors.complementary};
    width: 100%;
    text-align: center;
    position: absolute;
    height: 170px;
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.16);
    z-index: 9999999;
    top: 0;
    right: 0;
    p {
      padding: 24px 18px 0px 62px;
      text-align: right;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.56;
      color: ${Variables.colors.complementary_800};
    }
    .buttons {
      display: flex;
      justify-content: flex-end;
      padding: 0 16px;
      button {
        margin: 5px 8px;
        border: none;
        background: none;
        color: ${Variables.colors.complementary_700};
        font-size: 14px;
        font-weight: 500;
      }
      .get {
        color: ${Variables.colors.primary_vivid};
      }
    }
  }
`;
